import { Box, Container, Flex, Text, Image, Link, Spacer } from 'native-base';

import AppleAppStoreButton from 'assets/images/apple-app-store.png';
import PlayStoreButton from 'components/svgs/play-store-button';
import { AXLE_BUILD, AXLE_VERSION } from 'config/environment';

const versionString = AXLE_VERSION;
const appBuildString = AXLE_BUILD;

interface BaseProps {
  header?: JSX.Element | JSX.Element[] | null;
  content?: JSX.Element | JSX.Element[] | null;
  version?: string;
  appBuild?: string;
  bg?: string;
  isLogin?: boolean;
}

export default function Base({
  header,
  content,
  version = versionString,
  appBuild = appBuildString,
  bg = 'white',
  isLogin = false,
}: BaseProps): JSX.Element {
  return (
    <Box
      width={'100%'}
      height={{ base: '100vh', lg: '100vh' }}
      maxWidth="1920px"
      margin="auto"
      testID="Base"
      bg="white"
    >
      {isLogin ? (
        <Flex
          flexDirection={{ base: 'column', lg: 'row' }}
          flex={1}
          height={{ base: '100%', lg: 'auto' }}
          testID="container"
        >
          <Box flex={{ lg: 1 }}>
            <Container p="0px" maxWidth="100%" w="100%" bg={bg} zIndex="unset">
              <Box flexDirection={'row'} w="100%">
                {header}
              </Box>
              {appBuild && version && (
                <Flex
                  width="100%"
                  justify="center"
                  align="center"
                  pt="3.2px"
                  position="absolute"
                  top="2"
                >
                  <Text
                    testID="build-string"
                    fontSize="lg"
                    color="gray.200"
                  >{`${appBuild} - ${version}`}</Text>
                </Flex>
              )}
            </Container>
            <Container
              p="0px"
              maxWidth="100%"
              bg="white"
              position="initial"
              flex={1}
            >
              {content}
            </Container>
          </Box>
          <Box
            flex={1}
            backgroundColor="warmGray.50"
            paddingX={{ base: 4, lg: '48px' }}
            paddingTop={10}
            alignItems="center"
            justifyContent="center"
            overflow={'hidden'}
          >
            <Box
              width={{ lg: '50%' }}
              alignItems={{ base: 'center', lg: 'center' }}
              alignSelf={{ lg: 'flex-start' }}
            >
              <Text
                fontFamily={'InterSemibold'}
                fontSize={{ base: '20px', lg: '36px' }}
                lineHeight={{ lg: '52px' }}
                fontWeight={700}
                textAlign={{ base: 'center', lg: 'left' }}
              >
                Everything you need now lives in the ANNA Business Credit Cards App
              </Text>

              <Spacer height={8} />

              <Box
                backgroundColor="white"
                borderRadius="xl"
                padding={6}
                display="flex"
                flexDirection="column"
                alignItems="center"
                width={{ base: '100%', sm: '320px' }}
              >
                <Text
                  fontFamily="InterSemibold"
                  fontSize="lg"
                  marginBottom={4}
                  textAlign="center"
                >
                  Scan to download the app
                </Text>

                <Image
                  src="https://s.annamoney.au/h/izGQrJj?short_url_mode=qr"
                  alt="Download ANNA Credit App QR code"
                  width="220px"
                  height="220px"
                />
              </Box>

              <Spacer height={8} />

              <Box
                flexWrap={'wrap'}
                flexDirection={'row'}
                justifyContent={{ base: 'center', sm: 'flex-start' }}
              >
                <Link
                  href={
                    'https://apps.apple.com/au/app/cape-business-credit-cards/id6741783960'
                  }
                  isExternal
                  marginLeft={{ lg: '-12px' }}
                  padding={3}
                >
                  <Image
                    src={AppleAppStoreButton}
                    height={'47px'}
                    width={'146px'}
                    alt={'App Store Image'}
                  />
                </Link>
                <Link
                  href={
                    'https://play.google.com/store/apps/details?id=com.anna.money.credit'
                  }
                  isExternal
                  marginLeft={{ lg: '-12px' }}
                >
                  <PlayStoreButton />
                </Link>
              </Box>
            </Box>
          </Box>
        </Flex>
      ) : (
        <>
          <Container p="0px" maxWidth="100%" w="100%" bg={bg} zIndex="unset">
            {header}
            {appBuild && version && (
              <Flex
                width="100%"
                justify="center"
                align="center"
                pt="3.2px"
                position="absolute"
                top="2"
              >
                <Text
                  testID="build-string"
                  fontSize="lg"
                  color="gray.200"
                >{`${appBuild} - ${version}`}</Text>
              </Flex>
            )}
          </Container>
          <Container p="0px" maxWidth="100%" bg={bg} position="initial">
            {content}
          </Container>
        </>
      )}
    </Box>
  );
}
